import { render, staticRenderFns } from "./EditProjectList.vue?vue&type=template&id=7183527b&scoped=true"
import script from "./EditProjectList.vue?vue&type=script&lang=js"
export * from "./EditProjectList.vue?vue&type=script&lang=js"
import style0 from "./EditProjectList.vue?vue&type=style&index=0&id=7183527b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183527b",
  null
  
)

export default component.exports